/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";
import { Link } from "react-router-dom";

// Material UI table
import { MaterialReactTable } from "material-react-table";
import CRMListHeader from "../CRMListHeader/CRMListHeader";

/*import url and gateway methods */
import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import ListFilterPopup from "../Popup/ListFilterPopup";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import SaveListPopup from "../Popup/SaveListPopup";
import { crmCommonHeaderLinkLists } from "helper/CrmHelper/CrmHelper";
import { assetImages } from "constants";
import { useTranslation } from "react-i18next";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import ConversationNewMailPopup from "components/Common/Popup/ConversationNewMailPopup";
import { replaceListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import ViewListDetailsPopup from "../Popup/ViewListDetailsPopup";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

const CRMListBody = () => {
  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: "CRM", link: "/admin/crm/list" },
    { title: t("List") },
  ];

  // common header object
  const commonHeaderObject = crmCommonHeaderLinkLists(t);
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const [isLoading, setIsLoading] = useState(false);
  const [allList, setAllList] = useState([]);

  const [selectedListIds, setSelectedListIds] = useState([]);
  const [selectedListEmails, setSelectedListEmails] = useState([]);
  const [selectedListId, setSelectedListId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  const [isDataReady, setIsDataReady] = useState(false);

  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  // json filter query — starts as null so we can distinguish
  // "not yet decided" vs "decided: no filter"
  // null   = filter popup hasn't told us what to do yet (skip API call)
  // []     = filter popup said: no default filter, fetch all
  // [...]  = filter popup said: use these filters
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});

  //* alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  //get all lsit
  const getAllList = async (isFilter, filterQuery = []) => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_LIST + `?token=${token}`;

      requestUrl += `&isfilter=${isFilter}`;

      if (filterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = filterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl = requestUrl + `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      // console.log(requestUrl);

      const response = await getData(requestUrl);

      console.log("response of all list", response);

      if (response.status) {
        setAllList(response.data);
        setMessageType("success");
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setIsLoading(false);
      setShowAlert(true);
    }
  };

  //function for change status
  const changeStatusHandler = async () => {
    if (selectedListIds.length > 0) {
      let responseArr = [];

      for (let selectedId of selectedListIds) {
        try {
          let statusData = {
            status: "0",
          };

          let requestUrl =
            url.API_BASE_URL +
            url.API_UPDATE_A_LIST +
            `/${selectedId}` +
            `?token=${token}`;

          const response = await putData(requestUrl, statusData);

          if (response.status) {
            setMessageType("success");
            responseArr.push(true);
          } else {
            setMessageType("error");
          }

          setAlertMessage(response.message);
        } catch (error) {
          setMessageType("error");
          setAlertMessage(error.message);
        }

        setShowAlert(true);
      }

      if (responseArr.length > 0) {
        setTimeout(() => {
          getAllList();
        }, 2000);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select data for delete");
      setShowAlert(true);
    }
  };

  //remove tag from list
  const removeTagFromList = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_LIST;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedListId(null);
      }, 1000);
    }
  };

  // function for after action close
  const afterActionClose = (data = []) => {
    setAllList((prevList) => replaceListByIds(prevList, data));
  };

  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Actions"),
      Cell: ({ row }) => (
        <button
          className="action_btn_mui"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasSaveList"
          aria-controls="offcanvasSaveList"
          onClick={() => {
            setSelectedListId(row.original._id);
          }}
        >
          <span className="d-block material-symbols-outlined horz_icon">
            more_horiz
          </span>
        </button>
      ),
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    {
      accessorKey: "title",
      header: t("Title"),
    },
    {
      accessorKey: "tagstring",
      header: t("Label"),
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.taglist.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.taglist.map((tag, index) => (
                  <li key={index} className="d-inline-flex">
                    <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                      <span className="badge-text fs-xs fw-medium me-1">
                        {tag.title}
                      </span>
                      <Link
                        to="#"
                        className={`${
                          tag.moderator.toString() ===
                            userInfo._id.toString() ||
                          userInfo.role.slug === "ADMIN" ||
                          userInfo.role.slug === "SUPER_ADMIN"
                            ? "d-block"
                            : "d-none"
                        }`}
                        onClick={() => {
                          setSelectedListId(row.original._id);
                          setSelectedTagId(tag._id);
                          removeTagFromList([tag._id], row.original._id);
                        }}
                      >
                        {selectedTagId &&
                        selectedTagId === tag._id &&
                        selectedListId &&
                        selectedListId === row.original._id ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary ms-1"
                            role="status"
                            style={{ height: "12px", width: "12px" }}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <span
                            className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                            style={{ cursor: "pointer" }}
                          >
                            cancel
                          </span>
                        )}
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedListIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "listtypename",
      header: t("Type"),
    },
    {
      accessorKey: "moderatorname",
      header: t("Moderator"),
      Cell: ({ row }) => (
        <div className="owner border-bottom-0 d-flex gap-1">
          <img
            className="rounded-circle"
            height={40}
            width={40}
            src={
              row.original.moderatorimage == ""
                ? assetImages.defaultUser
                : url.SERVER_URL + row.original.moderatorimage
            }
            alt="Babcock"
          />
          <p>
            <span className="d-block fw-bold">
              {row.original.moderatorname}
            </span>
            <span className="d-block">{row.original.moderatoremail}</span>
          </p>
        </div>
      ),
    },
    {
      accessorKey: "_id",
      header: t("No of records"),
      Cell: ({ row }) => (
        <div className="d-flex align-items-center gap-4">
          {row.original.listtypename == "Company" ? (
            <p className="">
              {row.original.companycount > 0 ? row.original.companycount : "0"}
            </p>
          ) : row.original.listtypename == "Contact" ? (
            <p className="">
              {row.original.contactcount > 0 ? row.original.contactcount : "0"}
            </p>
          ) : row.original.listtypename === "Lead" ? (
            <p className="">
              {row.original.leadcount > 0 ? row.original.leadcount : "0"}
            </p>
          ) : (
            <p>0</p>
          )}
          <Link
            to="#"
            data-bs-toggle="offcanvas"
            data-bs-target="#viewListDetails"
            aria-controls="viewListDetails"
            onClick={() => {
              setSelectedListId(row.original._id);
            }}
          >
            <span className="material-symbols-outlined icon-md">
              chevron_right
            </span>
          </Link>
        </div>
      ),
    },
  ];

  //** Material React Table Column and States
  const columns = useMemo(
    () => initialTableColumns,
    [i18n.language, selectedTagId, selectedListId],
  );

  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  const onColumnVisiblityHandler = (newColumnState) => {
    const newColumnStateName = newColumnState();
    setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
  };

  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  // useEffect for row selection
  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );
    if (selectedIdsArray.length > 0) {
      const selectedListIdArr = selectedIdsArray.map((id) => {
        const [listId] = id.split("/");
        return listId;
      });

      const selectListEmails = selectedIdsArray.map((id) => {
        const [, listMail] = id.split("/");
        return listMail;
      });

      setSelectedListIds(selectedListIdArr);
      setSelectedListEmails(selectListEmails);
    } else {
      setSelectedListIds([]);
      setSelectedListEmails([]);
    }
  }, [rowSelection]);

  // Pagination save effect
  useEffect(() => {
    if (pagination.pageIndex > 0 || pagination.pageSize > 10) {
      setLastPagination({
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      });
    }
  }, [pagination.pageIndex, pagination.pageSize]);

  // ✅ Single API trigger — fires only after filter popup has decided what to do.
  // jsonFilterQuery starts as null (popup not ready yet).
  // Popup sets it to [] (no default filter → fetch all) or [...] (has filters → fetch filtered).
  // This way only ONE api call happens — never two.
  useEffect(() => {
    if (jsonFilterQuery === null) return; // Popup hasn't responded yet, wait

    if (jsonFilterQuery?.length > 0) {
      getAllList(true, jsonFilterQuery); // Filter query exists → filtered fetch
    } else {
      getAllList(false, []); // No filter → fetch all
    }

    setIsDataReady(true);
  }, [jsonFilterQuery]);

  // Reload effect — triggered by reset or refresh button
  useEffect(() => {
    if (reloadData) {
      setIsFilterReset(true);
      getAllList(false, []);
      setReloadData(false);
      setIsDataReady(true);
    }
  }, [reloadData]);

  //** function for reset filter
  const resetFilterData = () => {
    setSelectedListIds([]);
    setRowSelection({});
    setIsFilterReset(true);
    setJsonFilterQuery(null);
    setReloadData(true);
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  //* This is a function that is called when the alert close button is clicked.
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CRM") && moduleAccess.includes("MOD_LIST"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("List")}
          />
          <div className="container-fluid px-lg-5">
            <CRMListHeader
              breadcrumbText={breadcrumbText}
              reloadList={refreshRecords}
              selectedListIds={selectedListIds}
              jsonFilterQuery={jsonFilterQuery ?? []}
            />
            {/* ----------- table section ----------- */}
            {isLoading || !isDataReady ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={allList}
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => `${row._id}/${row.emails}`}
                  onRowSelectionChange={setRowSelection}
                  state={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  onPaginationChange={setPagination}
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  enableColumnOrdering={true}
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  defaultColumn={{ minSize: 20, maxSize: 300, size: 50 }}
                  muiTableContainerProps={{ sx: { maxHeight: "60vh" } }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
        </section>

        {/* ==== modals and popup section ==== */}
        <ListFilterPopup
          moduleSlug="crmlist"
          visibleColoumns={visibleColoumns}
          setVisibleColoumns={setVisibleColoumns}
          columnOrder={columnOrder}
          setColumnOrder={setColumnOrder}
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={refreshRecords}
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
          columns={columns}
        />

        {/* --- add new list --- */}
        <SaveListPopup
          afterSave={afterActionClose}
          listId={selectedListId}
          resetListId={() => {
            setSelectedListId(null);
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        <ViewListDetailsPopup
          listId={selectedListId}
          setListId={setSelectedListId}
          afterDeleteItem={afterActionClose}
        />

        <ConversationNewMailPopup
          contactPersonEmail={
            selectedListEmails.length > 0 ? selectedListEmails.join(", ") : ""
          }
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          moduleSlug="MOD_LIST"
        />

        {/* add label modal */}
        <AddLabelModal
          moduleName="list"
          selectedIds={selectedListIds}
          afterTagModalClose={afterActionClose}
          onModalClose={() => {
            setSelectedListIds([]);
            setRowSelection({});
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {/* ----------- delete warning modal ------------ */}
        <DeleteWarningModal
          onCancelDelete={() => {
            setRowSelection({});
            setSelectedListIds([]);
          }}
          onDelete={changeStatusHandler}
          moduleName={t("list")}
        />
        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};
export default CRMListBody;
